import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { APIS } from "../../../../../utils/APIS";
import { GET, POST, PUT, DELETE } from "../../../../../utils/Methods";
import { IDS } from "../../../../../utils/IDS";

// role - Get All (Read)
export const GetAll = createAsyncThunk(
  "metrological_traceability/get-all",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Metrological_Traceability}?term=${filter?.name ||
          ""}&page=${filter?.page || IDS.PAGE}&per_page=${filter?.per_page ||
          IDS.PERPAGE}&start_date=${filter?.start_date ||
          ""}&end_date=${filter?.end_date || ""}`,
      );
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

// role - Get (Read)
export const GetSingle = createAsyncThunk(
  "metrological_traceability/get",
  async (id, { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Metrological_Traceability}/${id}`);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

// role - Create (Add)
export const Create = createAsyncThunk(
  "metrological_traceability/create",

  async (data, { rejectWithValue }) => {
    console.log("this is called");
    try {
      const res = await POST(APIS.Metrological_Traceability, data);

      console.log("resresresres", res);
      return res; // The new role object
    } catch (error) {
      console.log(error, "error");

      return rejectWithValue(error);
    }
  },
);

// role - Update
export const Update = createAsyncThunk(
  "metrological_traceability/update",
  async ({ id, sendData }, { rejectWithValue }) => {
    try {
      const res = await PUT(
        `${APIS.Metrological_Traceability}/${id}`,
        sendData,
      );
      return res;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

// role - Delete
export const Delete = createAsyncThunk(
  "metrological_traceability/delete",
  async (id, { rejectWithValue }) => {
    try {
      const data = await DELETE(`${APIS.Metrological_Traceability}/${id}`);
      return id; // Return the id of the deleted role
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

// role - Status
export const StatusRole = createAsyncThunk(
  "metrological_traceability/status",
  async (id, { rejectWithValue }) => {
    try {
      const res = await POST(`${APIS.Metrological_Traceability}/${id}`);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const Slice = createSlice({
  name: "metrological_traceability",
  initialState: {
    data: [],
    current_page: IDS.PAGE,
    total_pages: IDS.TOTALPAGES,
    per_page: IDS.PERPAGE,
    total: IDS.TOTAL,
    status: IDS.SLICESTATUS.Idle,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Handling all actions for GetSingle, Create, Update, Delete
      .addCase(GetAll.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetAll.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data = action.payload?.data.data || [];
        state.current_page = action.payload?.data?.current_page || IDS.PAGE;
        state.total_pages = action.payload?.data?.total_pages || IDS.TOTALPAGES;
        state.per_page = action.payload?.data?.per_page || IDS.PERPAGE;
        state.total = action.payload?.data?.total || IDS.TOTAL;
      })
      .addCase(GetAll.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(GetSingle.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetSingle.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
      })
      .addCase(GetSingle.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(Create.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(Create.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        // state.data = action.payload;
        state.data.unshift(action.payload.data);
      })
      .addCase(Create.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(Update.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(Update.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        // state.data = action.payload;
        const index = state.data.findIndex(
          (role) => role.id === action.payload?.data?.id,
        );
        if (index !== -1) {
          state.data[index] = action.payload.data;
        }
      })
      .addCase(Update.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(Delete.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(Delete.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        // state.data = action.payload;
        state.data = state.data.filter((role) => role.id !== action.payload.id); // Remove the role with the deleted id
      })
      .addCase(Delete.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })
      //
      .addCase(StatusRole.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(StatusRole.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        // state.data = action.payload;
        state.data = state.data.filter((role) => role.id !== action.payload.id); // Remove the role with the deleted id
      })
      .addCase(StatusRole.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      });
  },
});

// Export actions (if needed in components)
export const {} = Slice.actions;

export default Slice.reducer;
